/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Card2X3Common from '@dtvgo/card-2x3';
import Icon from '@dtvgo/icon';

/* Utils */
import { CardType, CardWidth } from '../../utils/cardsUtils';
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import { ImageRatio } from '../../utils/constants';

/* Hooks */
import useImageCard from '../../hooks/useImageCard';

/* Styles */
import './Card2x3.scss';

const IMG_WIDTH = CardWidth[CardType.VOD] + 25;
const IMG_DIMENSION = ImageRatio.TWO_BY_THREE;

function Card2x3({
  className = '',
  focused,
  images,
  title = '',
  subtitle = '',
  isNonEntitledContent = false,
  isContentBlockedByParentalControl = false,
  hideMetadata = false,
  dark = false,
  onMouseDown,
  onMouseEnter,
}) {
  const { imageUrl } = useImageCard({
    images,
    imageSize: IMG_WIDTH,
    aspectRatio: IMG_DIMENSION,
  });

  return (
    <Card2X3Common
      className={
        `dtv-html5-c-card2x3 ${
          focused ? 'dtv-html5-c-card2x3--focused' : ''
        } ${className}`
      }
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
    >
      <Card2X3Common.Image
        className="dtv-html5-c-card2x3__image"
        imageUrl={imageUrl}
        imageAlt={title || ''}
        dark={dark}
      >
        {isNonEntitledContent && <Card2X3Common.Lock className="dtv-html5-c-card2x3__lock" />}
        {(isContentBlockedByParentalControl && !isNonEntitledContent) && (
          <div className="dtv-html5-c-card2x3__parental-control-block">
            <Icon name="parental-block" className="dtv-html5-c-card2x3__parental-control-icon" />
          </div>
        )}
      </Card2X3Common.Image>
      <div className={`dtv-html5-c-card2x3__metadata ${hideMetadata ? 'dtv-html5-c-card2x3__metadata--hidden' : ''}`}>
        <Card2X3Common.Title className="dtv-html5-c-card2x3__title">
          {title || ''}
        </Card2X3Common.Title>
        <Card2X3Common.SubTitle className="dtv-html5-c-card2x3__subtitle">
          {subtitle || ''}
        </Card2X3Common.SubTitle>
      </div>
    </Card2X3Common>
  );
}

Card2x3.propTypes = {
  className: PropTypes.string,
  focused: PropTypes.bool.isRequired,
  images: PropTypes.shape({
    ratio: PropTypes.string,
    height: PropTypes.number,
    type: PropTypes.string,
    url: PropTypes.string,
    width: PropTypes.number,
  }).isRequired,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  isNonEntitledContent: PropTypes.bool,
  isContentBlockedByParentalControl: PropTypes.bool,
  hideMetadata: PropTypes.bool,
  dark: PropTypes.bool,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

export default memo(withInteractiveFocusable()(memo(Card2x3)));
